import React from "react"
import T from 'components/common/translations/Translate';

const NoConnection = ({ loadContent }) => {
  return (
    <div className="no-results">
      <h3><T>Connection problems</T></h3>
      <p className="mb-40"><T>It seems you have lost connection</T></p>
      <button
        className="button button--outline button--expand"
        onClick={loadContent}
      >
        <T>refresh page</T>
      </button>
    </div>
  );
}

export default NoConnection;
